<template>
    <div
        class="w-full relative"
        style="padding: 56.25% 0 0 0;"
    >
        <iframe
            class="absolute inset-0 w-full h-full"
            v-if="url"
            :src="url"
            frameborder="0"
            allow="fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
    </div>
</template>

<script>
export default {
    props: {
        url: {
            required: true,
        }
    }
}
</script>
